module.exports = __webpack_public_path__ + "static/media/cozy9109.5eb6b875.jpg";